export const ru = {
    action_delete: 'Удалить',
    info: 'После удаления транзакции ее нельзя будет восстановить',
    title: 'Удалить транзакцию',
};
